/**
 * BeezFy Unified Drawer System
 * Cart drawer for premium experience
 */

(function() {
  'use strict';

  class BeezfyDrawer {
    constructor() {
      this.drawer = null;
      this.isOpen = false;
      this.init();
    }

    init() {
      this.createDrawer();
      this.bindEvents();

      // Make globally accessible
      window.BeezfyDrawer = this;
    }

    createDrawer() {
      // Check if drawer exists
      if (document.querySelector('.beezfy-drawer')) {
        this.drawer = document.querySelector('.beezfy-drawer');
        return;
      }

      // Create drawer HTML
      this.drawer = document.createElement('div');
      this.drawer.className = 'beezfy-drawer';
      this.drawer.innerHTML = `
        <div class="beezfy-drawer__overlay"></div>
        <div class="beezfy-drawer__container">
          <div class="beezfy-drawer__header">
            <h3 class="beezfy-drawer__title">Shopping Cart</h3>
            <button class="beezfy-drawer__close" aria-label="Close cart">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2"/>
              </svg>
            </button>
          </div>
          <div class="beezfy-drawer__content">
            <div class="beezfy-drawer__items"></div>
          </div>
          <div class="beezfy-drawer__footer">
            <div class="beezfy-drawer__subtotal">
              <span>Subtotal:</span>
              <span class="beezfy-drawer__subtotal-amount">$0.00</span>
            </div>
            <a href="/cart" class="beezfy-drawer__view-cart">View Cart</a>
            <a href="/checkout" class="beezfy-drawer__checkout">Checkout</a>
          </div>
        </div>
      `;

      document.body.appendChild(this.drawer);

      // Add styles if not present
      if (!document.querySelector('#beezfy-drawer-styles')) {
        const styles = document.createElement('style');
        styles.id = 'beezfy-drawer-styles';
        styles.textContent = `
          .beezfy-drawer {
            position: fixed;
            inset: 0;
            z-index: 999999;
            pointer-events: none;
          }
          .beezfy-drawer.active {
            pointer-events: auto;
          }
          .beezfy-drawer__overlay {
            position: absolute;
            inset: 0;
            background: rgba(0,0,0,0.5);
            opacity: 0;
            transition: opacity 0.3s;
          }
          .beezfy-drawer.active .beezfy-drawer__overlay {
            opacity: 1;
          }
          .beezfy-drawer__container {
            position: absolute;
            right: -400px;
            top: 0;
            bottom: 0;
            width: 400px;
            max-width: 100%;
            background: white;
            display: flex;
            flex-direction: column;
            transition: transform 0.3s;
            box-shadow: -2px 0 10px rgba(0,0,0,0.1);
          }
          .beezfy-drawer.active .beezfy-drawer__container {
            transform: translateX(-400px);
          }
          .beezfy-drawer__header {
            padding: 20px;
            border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .beezfy-drawer__title {
            margin: 0;
            font-size: 18px;
          }
          .beezfy-drawer__close {
            background: none;
            border: none;
            cursor: pointer;
            padding: 4px;
          }
          .beezfy-drawer__content {
            flex: 1;
            overflow-y: auto;
            padding: 20px;
          }
          .beezfy-drawer__footer {
            padding: 20px;
            border-top: 1px solid #eee;
          }
          .beezfy-drawer__subtotal {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            font-size: 18px;
            font-weight: bold;
          }
          .beezfy-drawer__view-cart,
          .beezfy-drawer__checkout {
            display: block;
            width: 100%;
            padding: 12px;
            text-align: center;
            text-decoration: none;
            border-radius: 4px;
            margin-bottom: 10px;
          }
          .beezfy-drawer__view-cart {
            background: #f5f5f5;
            color: #333;
          }
          .beezfy-drawer__checkout {
            background: #000;
            color: white;
          }
        `;
        document.head.appendChild(styles);
      }
    }

    bindEvents() {
      if (!this.drawer) return;

      // Close button
      const closeBtn = this.drawer.querySelector('.beezfy-drawer__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', () => {
          this.close();
        });
      }

      // Overlay click
      const overlay = this.drawer.querySelector('.beezfy-drawer__overlay');
      if (overlay) {
        overlay.addEventListener('click', () => {
          this.close();
        });
      }

      // DISABLED - causes infinite loop with new cart system
      // document.addEventListener('cart:updated', () => {
      //   this.refresh();
      // });
    }

    open() {
      if (!this.drawer) return;
      this.drawer.classList.add('active');
      document.body.classList.add('drawer-open');
      this.isOpen = true;
      this.refresh();
    }

    close() {
      if (!this.drawer) return;
      this.drawer.classList.remove('active');
      document.body.classList.remove('drawer-open');
      this.isOpen = false;
    }

    async refresh() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        this.updateContent(cart);
      } catch (error) {
        console.error('Failed to refresh cart:', error);
      }
    }

    updateContent(cart) {
      if (!this.drawer) return;

      const itemsContainer = this.drawer.querySelector('.beezfy-drawer__items');
      const subtotalElement = this.drawer.querySelector('.beezfy-drawer__subtotal-amount');

      if (!itemsContainer || !subtotalElement) return;

      if (cart.item_count === 0) {
        itemsContainer.innerHTML = '<p>Your cart is empty</p>';
      } else {
        itemsContainer.innerHTML = cart.items.map(item => `
          <div class="beezfy-drawer__item">
            <img src="${item.image}" alt="${item.title}" style="width: 60px; height: 60px; object-fit: cover;">
            <div style="flex: 1; margin-left: 15px;">
              <div>${item.title}</div>
              <div style="color: #666; font-size: 14px;">${item.variant_title || ''}</div>
              <div style="margin-top: 5px;">
                ${item.quantity} x ${this.formatMoney(item.price)}
              </div>
            </div>
          </div>
        `).join('');
      }

      // Update subtotal
      subtotalElement.textContent = this.formatMoney(cart.total_price);
    }

    formatMoney(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(cents / 100);
    }
  }

  // Initialize when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new BeezfyDrawer();
    });
  } else {
    new BeezfyDrawer();
  }

})();